import HttpService from '@/api/HttpService';

import {
  START_DOCUMENT_UPLOAD,
  STOP_DOCUMENT_UPLOAD,
  SET_NEEDS_DOCUMENTATION,
  SET_DOCUMENTATION_REASON,
} from '../mutation-types';

export default {
  namespaced: true,
  state: {
    documentIsUploading: false,
    needsDocumentation: null,
    documentationReason: '',
  },
  mutations: {
    [START_DOCUMENT_UPLOAD](state) {
      state.documentIsUploading = true;
    },
    [STOP_DOCUMENT_UPLOAD](state) {
      state.documentIsUploading = false;
    },
    [SET_NEEDS_DOCUMENTATION](state, value) {
      state.needsDocumentation = value;
    },
    [SET_DOCUMENTATION_REASON](state, reason) {
      state.documentationReason = reason;
    },
  },
  actions: {
    checkIfUserNeedsDocumentation({ commit }) {
      commit(SET_NEEDS_DOCUMENTATION, null);
      commit(SET_DOCUMENTATION_REASON, '');
      return HttpService.getV2('users/user/needs-documentation').then((data) => {
        commit(SET_NEEDS_DOCUMENTATION, data.needs);
        commit(SET_DOCUMENTATION_REASON, data.reason || '');
        return true;
      });
    },
    uploadDocument({ commit }, { file, data }) {
      commit(START_DOCUMENT_UPLOAD);
      return HttpService.uploadFileV2('users/dwolla-documentation', file, data)
        .then((response) => {
          commit(STOP_DOCUMENT_UPLOAD);
          return response;
        })
        .catch((error) => {
          commit(STOP_DOCUMENT_UPLOAD);
          return Promise.reject(error);
        });
    },
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/documentUpload.js